webpackJsonp([1],{

/***/ "./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/index.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Raleway:100,200,300);", ""]);
exports.i(__webpack_require__("./node_modules/css-loader/index.js!./node_modules/platformicons/platformicons/platformicons.css"), "");
exports.i(__webpack_require__("./node_modules/css-loader/index.js!./node_modules/typeface-rubik/index.css"), "");

// module
exports.push([module.i, ".platform-icon:before{height:50px;width:50px;font-family:platformicons;color:#fff;font-size:32px;-webkit-font-smoothing:antialiased;display:block;height:100%;border-radius:3px 0 0 3px;text-align:center;line-height:48px}.c:before{content:\"C\";font-family:Raleway;font-weight:300;background:#a9b9cb;line-height:50px}.cocoa:before{content:\"\\E60A\";background:red}.csharp:before{content:\"\\E60F\";background:#0090ff}.elixir:before{content:\"\\E903\";background:#4e3fb4}.go:before{content:\"\\E606\";background:#fff;color:#000}.java:before{content:\"\\E608\";background:#ff8a00}.javascript:before{content:\"\\E600\";background:#ffd906}.node:before{content:\"\\E609\";background:#8ac655}.objc:before{content:\"\\E60E\";background:#02bfd0}.php:before{content:\"\\E601\";background:#4f5b93}.python:before{content:\"\\E602\";background:#3776ab}.ruby:before{content:\"\\E604\";background:#d00202}.perl:before{content:\"\\E901\";background:#9d95a4}.other:before{content:\"\\E60A\";background:#afafaf}#root,body,html{height:100%}#root,#sentry_echo,body{min-height:100%;margin:0;padding:0}body{background:#15121c;color:#fff;font-family:Rubik;font-weight:300}a{color:#6c5fc7;text-decoration:none;transition:color .3s}a:hover{color:#423b87}#sentry_echo,header{display:flex;flex-direction:column}header{flex-grow:0;padding:20px 0;text-align:center}header p{padding-top:25px;width:570px;line-height:1.9em;margin:0 auto;font-size:.9rem;color:#fff;animation:flavorText 10s linear 1 forwards}@keyframes flavorText{50%{opacity:1}to{opacity:.25}}.logo{display:flex;font-family:Raleway;margin:0 auto}.logo h1:first-child{width:200px;height:70px;background:url(\"https://sentry-brand.storage.googleapis.com/sentry-logo-white.svg\") no-repeat;text-indent:-9999px}.logo h1:last-child{font-weight:100;text-transform:lowercase;line-height:68px;position:relative}.main-app{position:relative;flex-grow:1;display:flex;justify-content:center;padding:80px 0}.sequencers{list-style:none;margin:0;padding:0}.sequencers li:not(:last-child){margin-bottom:8px}.platform{display:flex;width:800px;transition:opacity .5s,filter .5s}.platform.muted{opacity:.2}.instrument-heading{display:flex;text-transform:uppercase;font-size:.8rem;align-items:center;padding:4px 0;user-select:none}.instrument-heading:after{content:\"\";border-bottom:1px solid #333;flex-grow:1;margin-left:10px}.note-indicator{display:block;width:4px;background:#353042;margin-left:6px;transition:background .3s}.note-indicator.trigger{background:#f36e4f}@keyframes noteIndicatorTrigger{20%{background:#e03e2f}}.sequence-timeline{overflow:hidden;position:relative;margin-left:6px;background:hsla(0,0%,100%,.01);flex-grow:1}.sequence-timeline svg{display:block;shape-rendering:crispEdges}.sequence-timeline svg .bar-lines line{stroke-width:1px;stroke:#2a2140}.sequence-timeline svg .playlist rect{fill:#9990ab;opacity:0;transform:translateX(8px);animation:showNote .4s;animation-fill-mode:forwards}.sequence-timeline svg .playlist rect:first-child,.sequence-timeline svg .playlist rect:nth-child(2){animation-delay:90ms}.sequence-timeline svg .playlist rect:nth-child(3),.sequence-timeline svg .playlist rect:nth-child(4){animation-delay:.18s}.sequence-timeline svg .playlist rect:nth-child(5),.sequence-timeline svg .playlist rect:nth-child(6){animation-delay:.27s}.sequence-timeline svg .playlist rect:nth-child(7),.sequence-timeline svg .playlist rect:nth-child(8){animation-delay:.36s}.sequence-timeline svg .playlist rect:nth-child(9),.sequence-timeline svg .playlist rect:nth-child(10){animation-delay:.45s}.sequence-timeline svg .playlist rect:nth-child(11),.sequence-timeline svg .playlist rect:nth-child(12){animation-delay:.54s}.sequence-timeline svg .playlist rect:nth-child(13),.sequence-timeline svg .playlist rect:nth-child(14){animation-delay:.63s}.sequence-timeline svg .playlist rect:nth-child(15),.sequence-timeline svg .playlist rect:nth-child(16){animation-delay:.72s}.sequence-timeline svg .playlist rect:nth-child(17),.sequence-timeline svg .playlist rect:nth-child(18){animation-delay:.81s}.sequence-timeline svg .playlist rect:nth-child(19),.sequence-timeline svg .playlist rect:nth-child(20){animation-delay:.9s}.sequence-timeline svg .playlist rect:nth-child(21),.sequence-timeline svg .playlist rect:nth-child(22){animation-delay:.99s}.sequence-timeline svg .playlist rect:nth-child(23),.sequence-timeline svg .playlist rect:nth-child(24){animation-delay:1.08s}.sequence-timeline svg .playlist rect:nth-child(25),.sequence-timeline svg .playlist rect:nth-child(26){animation-delay:1.17s}.sequence-timeline svg .playlist rect:nth-child(27),.sequence-timeline svg .playlist rect:nth-child(28){animation-delay:1.26s}.sequence-timeline svg .playlist rect:nth-child(29),.sequence-timeline svg .playlist rect:nth-child(30){animation-delay:1.35s}.sequence-timeline svg .playlist rect:nth-child(31),.sequence-timeline svg .playlist rect:nth-child(32){animation-delay:1.44s}@keyframes showNote{60%{opacity:1}to{opacity:1;transform:translateX(0)}}.playhead{top:0;left:0;border-right:1px solid #6c5fc7;transform:translateX(0);opacity:0;transition:opacity .1s;z-index:2}.playhead,.playhead:before{position:absolute;height:100%}.playhead:before{content:\"\";display:block;width:10px;left:-10px;background:linear-gradient(90deg,rgba(108,95,199,0),rgba(108,95,199,.2))}.playhead.shown{opacity:1}.bpm-indicator{position:absolute;top:10px;font-weight:400;font-size:1.2rem;line-height:1.2rem;text-align:center;color:#f58159;transition:opacity .6s,transform .6s;opacity:0;transform:translateY(47px);pointer-events:none}.bpm-indicator.ready{opacity:1;transform:translateY(0)}.bpm-indicator div,.bpm-indicator small{color:#fff;font-weight:100}.bpm-indicator small{font-size:.65rem;margin-left:2px}.bpm-indicator div{font-size:.8rem;opacity:.6}.loading-sequence{position:absolute;top:20px;background:#e03e2f;font-size:.8rem;padding:5px 10px;border-radius:3px;animation:waitNotify 1s;transition:opacity .6s}.loading-sequence.ready{opacity:0;pointer-events:none}@keyframes waitNotify{0%{opacity:0}60%{opacity:0}to{opacity:1}}.help-popover{position:absolute;top:0;right:0;height:0}.help-popover .popover{width:600px;padding:40px;background:#fff;color:#342c3e;z-index:10;position:relative;border-radius:4px;top:90px;right:18px;font-size:.9rem;line-height:1.5rem;box-shadow:0 50px 100px rgba(50,50,93,.1),0 15px 35px rgba(50,50,93,.15),0 5px 15px rgba(0,0,0,.1);pointer-events:none;transform:rotate3d(1,1,0,15deg);transform-origin:100% 0;opacity:0;will-change:transform,opacity;transition-property:transform,opacity;transition-duration:.25s}.help-popover .popover:after{display:block;content:\"\";border:10px solid transparent;border-bottom-color:#fff;height:0;width:0;position:absolute;top:-20px;right:24px}.help-popover h1{margin:8px 0;font-size:.8rem;font-weight:600;text-transform:uppercase}.help-popover span{position:absolute;top:40px;right:40px;line-height:23px;width:25px;display:block;border-radius:50%;text-align:center;font-weight:100;color:hsla(0,0%,100%,.4);font-size:.9rem;padding-top:2px;cursor:pointer;transition:background .3s,color .3s}.help-popover.opened span,.help-popover span:hover{background:#fff;color:#a69db9}.help-popover.opened .popover{transform:none;opacity:1;pointer-events:auto}.help-popover p::selection{background:#d1cbe6}", ""]);

// exports


/***/ }),

/***/ "./src/App.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _tone = __webpack_require__("./node_modules/tone/build/Tone.js");

var _tone2 = _interopRequireDefault(_tone);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _animejs = __webpack_require__("./node_modules/animejs/anime.min.js");

var _animejs2 = _interopRequireDefault(_animejs);

var _reactAnimatedNumber = __webpack_require__("./node_modules/react-animated-number/build/index.js");

var _reactAnimatedNumber2 = _interopRequireDefault(_reactAnimatedNumber);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__("./src/index.scss");

var _howItWorks = __webpack_require__("./src/how-it-works.svg");

var _howItWorks2 = _interopRequireDefault(_howItWorks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var platforms = ['javascript', 'node', 'python', 'ruby', 'cocoa', 'csharp', 'elixir', 'go', 'java', 'objc', 'php', 'perl', 'c', 'other'];

// Startup the tone transport. We start the transport a bit in the future since
// we won't have a sequence to fire until we build the fisrt sequence.
_tone2.default.Transport.start('+1');

// Default BPM
_tone2.default.Transport.bpm.value = 160;

// Put Tone on the window for debuggin purposes
window.Tone = _tone2.default;

var instrumentGroups = ['Lead Synth', 'Kick Drum', 'Bass Line'];

var scale = ['C', 'D', 'E', 'F', 'G', 'A', 'B'];

var defaultGrouping = [['javascript', 'python', 'node', 'php'], ['go', 'csharp', 'ruby'], ['java', 'elixir', 'c', 'other']];

// XXX: Disable unused groupings to save on memory
platforms = _lodash2.default.flatten(defaultGrouping);

var synthBank = [{
  javascript: new _tone2.default.PluckSynth().toMaster(),
  python: new _tone2.default.PluckSynth().toMaster(),
  node: new _tone2.default.PluckSynth().toMaster(),
  php: new _tone2.default.PluckSynth().toMaster()
}, {
  go: new _tone2.default.MembraneSynth().toMaster(),
  csharp: new _tone2.default.MembraneSynth().toMaster(),
  ruby: new _tone2.default.MembraneSynth().toMaster()
}, {
  java: new _tone2.default.FMSynth().toMaster(),
  elixir: new _tone2.default.FMSynth().toMaster(),
  c: new _tone2.default.FMSynth().toMaster(),
  other: new _tone2.default.FMSynth().toMaster()
}];

var groupConfigs = {
  javascript: {
    countDivision: 5,
    noteLength: '64n',
    quantizeTo: '8n'
  },
  python: {
    countDivision: 5,
    noteLength: '64n',
    quantizeTo: '8n',
    offset: '16n'
  },
  php: {
    countDivision: 6,
    noteLength: '16n',
    quantizeTo: '4n',
    offset: '14n',
    startMuted: true
  },
  csharp: {
    offset: '8n'
  },
  ruby: {
    startMuted: true
  },
  java: {
    countDivision: 4,
    noteLength: '32n',
    quantizeTo: '1:0'
  },
  elixir: {
    countDivision: 1,
    noteLength: '32n',
    quantizeTo: '0:2'
  }
};

var SeqeuenceCanvas = function (_Component) {
  _inherits(SeqeuenceCanvas, _Component);

  function SeqeuenceCanvas() {
    _classCallCheck(this, SeqeuenceCanvas);

    return _possibleConstructorReturn(this, (SeqeuenceCanvas.__proto__ || Object.getPrototypeOf(SeqeuenceCanvas)).apply(this, arguments));
  }

  _createClass(SeqeuenceCanvas, [{
    key: 'makeBarGrid',
    value: function makeBarGrid() {
      var _this2 = this;

      var widthPerBar = _tone2.default.Time('1:0:0').div(this.props.sequenceSize).mult(this.props.width).toSeconds();

      var totalBars = Math.floor(this.props.width / widthPerBar);

      return _lodash2.default.times(totalBars, function (i) {
        return _react2.default.createElement('line', { key: i,
          x1: Math.floor(widthPerBar * (i + 1)),
          x2: Math.floor(widthPerBar * (i + 1)),
          y1: 0,
          y2: _this2.props.height });
      });
    }
  }, {
    key: 'makeNote',
    value: function makeNote(note) {
      var paddingX = 1;
      var paddingY = 2;

      var height = this.props.height / scale.length - paddingY * 2;
      var rawWidth = note.length.clone().div(this.props.sequenceSize).mult(this.props.width).toSeconds();

      // Notes may play for a very short period of time, but at least give them a
      // pixel representation
      var width = Math.max(1, rawWidth);

      var x = note.relTime.clone().div(this.props.sequenceSize).mult(this.props.width).toSeconds() + paddingX;

      var y = Math.floor(note.scaleIndex * (this.props.height / scale.length)) + paddingY;

      return _react2.default.createElement('rect', { key: note.time.toSeconds(),
        height: height,
        width: width,
        x: x,
        y: y });
    }
  }, {
    key: 'makePlaylist',
    value: function makePlaylist() {
      var _this3 = this;

      return this.props.playlist.map(function (n) {
        return _this3.makeNote(n);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        { width: this.props.width, height: this.props.height },
        _react2.default.createElement(
          'g',
          { className: 'bar-lines' },
          this.makeBarGrid()
        ),
        _react2.default.createElement(
          'g',
          { className: 'playlist' },
          this.makePlaylist()
        )
      );
    }
  }]);

  return SeqeuenceCanvas;
}(_react.Component);

var PlatformSequence = function (_Component2) {
  _inherits(PlatformSequence, _Component2);

  function PlatformSequence() {
    _classCallCheck(this, PlatformSequence);

    var _this4 = _possibleConstructorReturn(this, (PlatformSequence.__proto__ || Object.getPrototypeOf(PlatformSequence)).call(this));

    _this4.state = {
      isMuted: false,
      playheadShown: false,
      playlist: []
    };

    _this4.timeline = null;
    _this4.playhead = null;
    _this4.playheadAnim = null;
    _this4.noteIndicator = null;

    _this4.playingNotes = 0;

    _this4.mute = _this4.mute.bind(_this4);
    _this4.setPlayhead = _this4.setPlayhead.bind(_this4);
    _this4.processEvents = _this4.processEvents.bind(_this4);
    _this4.noteStart = _this4.noteStart.bind(_this4);
    _this4.noteEnd = _this4.noteEnd.bind(_this4);
    _this4.updatePlaylist = _this4.updatePlaylist.bind(_this4);
    return _this4;
  }

  _createClass(PlatformSequence, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ muted: this.props.startMuted });
      this.props.synth.volume.value = this.props.startMuted ? -100 : 0;

      var start = this.props.sequenceSize;

      // Schedule repeating event sampling for this platform
      new _tone2.default.Loop(this.processEvents, this.props.sequenceSize).start(start);
    }
  }, {
    key: 'processEvents',
    value: function processEvents(time) {
      var _this5 = this;

      // XXX: This isn't great that we're directly mutating this here, probably
      // would be nicer to keep doing things in a react-esq way in which case
      // this *should* be immutable, but whatever, it's a hackweek project.
      var entries = this.props.eventBuffer[this.props.platform].sort();
      this.props.eventBuffer[this.props.platform] = [];

      // Normalize entry timestamps to seconds starting relative to the start of
      // the upcoming sequence.
      var earliestTime = entries[0];
      entries = entries.map(function (e) {
        return _tone2.default.Time((e - earliestTime) / 1000);
      });

      // We compute where the notes land on the grid by [1] quantizing them onto
      // the grid based on the quantizeTo property, then determining how long the
      // note should last by [2] taking the number of events quantized to the
      // same time, [3] dividing that by the countDivision, and multiplying that
      // by the noteLength property.
      //
      // [4] Notes are moved up and down the scale when they would otherwise
      // overlap with another note before it's completed.

      // [1]: Quanitze error timestamps
      entries = entries.map(function (e) {
        return e.quantize(_this5.props.quantizeTo);
      });

      // Remove any entires that fall *outside* of the next sequence
      entries = entries.filter(function (e) {
        return e < _this5.props.sequenceSize;
      });

      // [2]: Group timestamps based on overlap
      var groups = Object.values(_lodash2.default.groupBy(entries, function (e) {
        return e.toSeconds();
      }));

      // [3]: Offset the time and compute the note length
      entries = groups.map(function (e) {
        return {
          relTime: e[0].add(_this5.props.offset),
          time: e[0].clone().add(time),
          length: _tone2.default.Time(e.length / _this5.props.countDivision).mult(_this5.props.noteLength)
        };
      });

      // Start at a random note. Maybe a good idea, maybe bad
      var scaleIndex = Math.floor(Math.random() * (scale.length - 1));
      entries[0].scaleIndex = scaleIndex;

      // [4]: Move notes through the scale if notes overlap nessicary
      for (var i = 1; i < entries.length; i++) {
        var curr = entries[i];
        var last = entries[i - 1];

        var dir = [-1, 1][Math.floor(Math.random() * 2)];

        curr.scaleIndex = last.time.clone().add(last.length) > curr.time ? scaleIndex = Math.abs(scaleIndex + dir) % scale.length : scaleIndex;
      }

      // Schedule notes to be played
      entries.forEach(function (n) {
        var note = '' + scale[n.scaleIndex] + _this5.props.instrumentIndex;
        _this5.props.synth.triggerAttackRelease(note, n.length, n.time);
      });

      // Schedule beat-indicator triggers for each note.
      // TODO: This is sometimes a little bit buggy
      entries.forEach(function (e) {
        _tone2.default.Draw.schedule(_this5.noteStart, e.time);
        _tone2.default.Draw.schedule(_this5.noteEnd, e.time.clone().add(e.length));
      });

      // Schedule redrawing of the sequence grid and playhead
      _tone2.default.Draw.schedule(function (_) {
        return _this5.updatePlaylist(entries);
      }, time);
      _tone2.default.Draw.schedule(this.setPlayhead, time);
    }
  }, {
    key: 'updatePlaylist',
    value: function updatePlaylist(entries) {
      this.setState({ playlist: entries });
    }
  }, {
    key: 'noteStart',
    value: function noteStart() {
      this.playingNotes++;
      this.noteIndicator.classList.add('trigger');
    }
  }, {
    key: 'noteEnd',
    value: function noteEnd() {
      if (this.playingNotes-- === 1) {
        this.noteIndicator.classList.remove('trigger');
      }
    }
  }, {
    key: 'setPlayhead',
    value: function setPlayhead() {
      this.setState({ playheadShown: true });

      _animejs2.default.remove(this.playhead);
      this.playhead.style.transform = 'translateX(0)';

      this.playheadAnim = (0, _animejs2.default)({
        targets: this.playhead,
        duration: this.props.sequenceSize.toMilliseconds(),
        translateX: this.timeline.clientWidth,
        easing: 'linear'
      });
    }
  }, {
    key: 'mute',
    value: function mute() {
      var muted = !this.state.muted;
      this.setState({ muted: muted });
      this.props.synth.volume.value = muted ? -100 : 0;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      return _react2.default.createElement(
        'li',
        {
          className: (0, _classnames2.default)('platform', { muted: this.state.muted }),
          onClick: this.mute },
        _react2.default.createElement('span', { className: (0, _classnames2.default)('platform-icon', this.props.platform) }),
        _react2.default.createElement('span', { className: 'note-indicator', ref: function ref(n) {
            return _this6.noteIndicator = n;
          } }),
        _react2.default.createElement(
          'div',
          { className: 'sequence-timeline', ref: function ref(n) {
              return _this6.timeline = n;
            } },
          _react2.default.createElement('span', {
            className: (0, _classnames2.default)('playhead', { shown: this.state.playheadShown }),
            ref: function ref(n) {
              return _this6.playhead = n;
            } }),
          _react2.default.createElement(SeqeuenceCanvas, {
            playlist: this.state.playlist,
            sequenceSize: this.props.sequenceSize,
            width: 734,
            height: 48 })
        )
      );
    }
  }]);

  return PlatformSequence;
}(_react.Component);

PlatformSequence.defaultProps = {
  countDivision: 5,
  noteLength: '64n',
  quantizeTo: '2n',
  offset: 0
};

var HelpPopover = function (_Component3) {
  _inherits(HelpPopover, _Component3);

  function HelpPopover() {
    _classCallCheck(this, HelpPopover);

    var _this7 = _possibleConstructorReturn(this, (HelpPopover.__proto__ || Object.getPrototypeOf(HelpPopover)).call(this));

    _this7.state = { opened: false };
    return _this7;
  }

  _createClass(HelpPopover, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this8 = this;

      document.addEventListener('click', function (e) {
        if (!_this8.popover.contains(e.target)) {
          _this8.setState({ opened: false });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this9 = this;

      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)('help-popover', { opened: this.state.opened }),
          ref: function ref(n) {
            return _this9.popover = n;
          } },
        _react2.default.createElement(
          'span',
          { onClick: function onClick(_) {
              return _this9.setState({ opened: !_this9.state.opened });
            } },
          '?'
        ),
        _react2.default.createElement(
          'div',
          { className: 'popover' },
          _react2.default.createElement(
            'h1',
            null,
            'What is this?'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Sentry echo is a Winter 2017 hack-week project that sprung about from wanting to play with the live data available through ',
            _react2.default.createElement(
              'a',
              { href: 'http://live.sentry.io' },
              'live.sentry.io'
            ),
            '.  Echo generates music using the live stream of errors collected by sentry, placing notes onto a sequence using the error timestamp and it\'s platform.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Sentry echo was created by Evan Purkhiser.'
          ),
          _react2.default.createElement(
            'h1',
            null,
            'How does it work?'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Errors are collected over the HTTP Message Stream ',
            _react2.default.createElement(
              'a',
              {
                href: 'http://live.sentry.io:7000' },
              'live.sentry.io:7000'
            ),
            ' and buffered into platform groups. We then sequence the errors collected over a 4 musical bar period onto a scale. We then do some manipulations based on the timestamp of the event to algin them onto the sequence.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement('img', { src: _howItWorks2.default })
          ),
          _react2.default.createElement(
            'p',
            null,
            'The BPM for each sequence is computed by taking the total number of errors collected during that period, comuputing the rate of errors per second, and dividing that by a constant to get a sane BPM.'
          )
        )
      );
    }
  }]);

  return HelpPopover;
}(_react.Component);

var heading = _react2.default.createElement(
  'header',
  null,
  _react2.default.createElement(
    'div',
    { className: 'logo' },
    _react2.default.createElement(
      'h1',
      null,
      'Sentry'
    ),
    _react2.default.createElement(
      'h1',
      null,
      'Echo'
    )
  ),
  _react2.default.createElement(
    'p',
    null,
    'Listen the beautiful soundscape generated by software breaking around the world. Hear the sound of errors \u2014 Powered by sentry.io'
  )
);

var App = function (_Component4) {
  _inherits(App, _Component4);

  function App() {
    _classCallCheck(this, App);

    var _this10 = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this));

    _this10.state = {
      globalSequenceSize: _tone2.default.Time('4:0:0'),
      ordering: _lodash2.default.cloneDeep(defaultGrouping),

      bpmDivider: 6,
      currentBpm: new Number(0),
      eventsPerSecond: new Number(0)
    };

    _this10.eventBuffer = _lodash2.default.fromPairs(platforms.map(function (p) {
      return [p, []];
    }));
    _this10.eventsPerSequence = 0;

    _this10.starting = _this10.starting.bind(_this10);
    _this10.recomputeBpm = _this10.recomputeBpm.bind(_this10);
    return _this10;
  }

  _createClass(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this11 = this;

      this.props.eventStream.onmessage = this.processEvents.bind(this);

      var start = this.state.globalSequenceSize;
      _tone2.default.Transport.scheduleOnce(function (t) {
        return _tone2.default.Draw.schedule(_this11.starting, t);
      }, start);

      // The BPM should be updated *just* before any other updates are scheduled
      var oneTickBack = start.clone().sub('1i');
      new _tone2.default.Loop(this.recomputeBpm, this.state.globalSequenceSize).start(oneTickBack);
    }
  }, {
    key: 'processEvents',
    value: function processEvents(message) {
      var _JSON$parse = JSON.parse(message.data),
          _JSON$parse2 = _slicedToArray(_JSON$parse, 4),
          latitude = _JSON$parse2[0],
          longitude = _JSON$parse2[1],
          ts = _JSON$parse2[2],
          platform = _JSON$parse2[3];

      if (this.eventBuffer[platform] === undefined) {
        return;
      }

      this.eventsPerSequence++;
      this.eventBuffer[platform].push(ts);
    }
  }, {
    key: 'starting',
    value: function starting() {
      this.setState({ playing: true });
    }
  }, {
    key: 'recomputeBpm',
    value: function recomputeBpm(time) {
      var _this12 = this;

      var eventCount = this.eventsPerSequence;
      this.eventsPerSequence = 0;

      var eventsPerSecond = eventCount / this.state.globalSequenceSize;
      var currentBpm = eventsPerSecond / this.state.bpmDivider;

      _tone2.default.Draw.schedule(function (_) {
        return _this12.setState({ eventsPerSecond: eventsPerSecond, currentBpm: currentBpm });
      }, time);

      // Update the BPM of the transport at the precise time
      _tone2.default.Transport.bpm.value = currentBpm;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this13 = this;

      var sequencerList = this.state.ordering.map(function (items, i) {
        var heading = _react2.default.createElement(
          'li',
          { key: i, className: 'instrument-heading' },
          instrumentGroups[i]
        );

        var sequencers = items.map(function (p, j) {
          return _react2.default.createElement(PlatformSequence, _extends({ key: p
          }, groupConfigs[p], {
            synth: synthBank[i][p],
            instrumentIndex: j + 2,
            sequenceSize: _this13.state.globalSequenceSize,
            eventBuffer: _this13.eventBuffer,
            platform: p }));
        });

        return [heading, sequencers];
      });

      var readyClass = { ready: this.state.playing };

      var loader = _react2.default.createElement(
        'span',
        { className: (0, _classnames2.default)('loading-sequence', readyClass) },
        'Waiting ',
        this.state.globalSequenceSize.toSeconds().toFixed(1) + ' ',
        'seconds for first sequence of events...'
      );

      var bpmClasses = (0, _classnames2.default)('bpm-indicator', {
        ready: this.state.playing
      });

      var bpmIndicator = _react2.default.createElement(
        'h1',
        { className: (0, _classnames2.default)('bpm-indicator', readyClass) },
        _react2.default.createElement(_reactAnimatedNumber2.default, {
          value: this.state.currentBpm,
          formatValue: function formatValue(n) {
            return n.toFixed(2);
          },
          duration: 600 }),
        _react2.default.createElement(
          'small',
          null,
          'BPM'
        ),
        _react2.default.createElement(
          'div',
          null,
          this.state.eventsPerSecond.toFixed(1) + ' ',
          'errors \u2215 second \xF7 ',
          this.state.bpmDivider
        )
      );

      return _react2.default.createElement(
        'div',
        { id: 'sentry_echo' },
        heading,
        _react2.default.createElement(HelpPopover, null),
        _react2.default.createElement(
          'div',
          { className: 'main-app' },
          loader,
          bpmIndicator,
          _react2.default.createElement(
            'ul',
            { className: 'sequencers' },
            sequencerList
          )
        )
      );
    }
  }]);

  return App;
}(_react.Component);

exports.default = App;

/***/ }),

/***/ "./src/how-it-works.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "77787333af8eca0b5a2b27444df0a7f9.svg";

/***/ }),

/***/ "./src/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _App = __webpack_require__("./src/App.js");

var _App2 = _interopRequireDefault(_App);

__webpack_require__("./src/index.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stream = new EventSource("https://live.sentry.io/stream");

_reactDom2.default.render(_react2.default.createElement(_App2.default, { eventStream: stream }), document.getElementById("root"));

/***/ }),

/***/ "./src/index.scss":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/index.scss");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(true) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/index.scss", function() {
			var newContent = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/index.scss");
			if(typeof newContent === 'string') newContent = [[module.i, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ })

},["./src/index.js"]);


// WEBPACK FOOTER //
// main.8db94a687b03673a8545.js